import { useCallback, useEffect, useState } from 'react';
import { api } from '@/api/user-dashboard/api';
import { useNavigate } from 'react-router-dom';
import Tooltip from '@components/common/Tooltip';

const AgencyInfoCard = () => {
    const navigate = useNavigate();
    const [agencyInfo, setAgencyInfo] = useState({
        userName: '',
        address: '',
        phone: '',
        email: '',
        userId: '',
    });

    const getAgencyInfo = useCallback(async () => {
        const result = await api.corporationInfo();
        setAgencyInfo({
            userName: result.userName || '',
            address: result.address || '',
            phone: result.phone || '',
            email: result.email || '',
            userId: result.userId || '',
        });
    }, []);

    useEffect(() => {
        getAgencyInfo();
    }, [getAgencyInfo]);

    return (
        <>
            <div className="custom-card job-candidate-details card">
                <div
                    className="border-bottom card-body"
                    style={{
                        background:
                            'url(/images/media/media-67.png) 100% -2px no-repeat',
                        backgroundPositionX: 'right',
                    }}
                >
                    <div className="d-flex gap-2 flex-xl-nowrap flex-wrap align-items-center">
                        <div className="lh-1 flex-shrink-0">
                            <div
                                className="rounded-3 d-flex align-items-center justify-content-center text-white fw-bold"
                                style={{
                                    width: 66,
                                    height: 66,
                                    background: 'rgb(240 255 241)',
                                    backdropFilter: 'blur(4px)',
                                    border: '1.5px solid rgba(28 145 76)',
                                    flexShrink: 0,
                                    fontSize: 26,
                                }}
                            >
                                🌿
                            </div>
                        </div>
                        <div className="d-flex gap-2 flex-xl-nowrap flex-wrap flex-grow-1">
                            <div className="flex-fill">
                                <h6 className="mb-1 fw-semibold">
                                    <a data-discover="true">
                                        {agencyInfo.userName}
                                        <i className="bi bi-patch-check-fill text-success lh-1 mx-1"></i>
                                    </a>
                                </h6>
                                <p className="mb-0 text-muted">
                                    <i className="ri-map-pin-line me-1"></i>
                                    {agencyInfo.address}{' '}
                                    <Tooltip
                                        content="최초 주소값은 접속 IP 기반으로 등록됩니다."
                                        customClass="tooltip-dark"
                                        placement="top"
                                    >
                                        <i className="ri-question-line" />
                                    </Tooltip>
                                </p>
                                <div className="d-flex flex-wrap gap-2 align-items-center fs-12 text-muted">
                                    <div className="fw-medium">
                                        <i className="ri-phone-line text-success fs-15"></i>{' '}
                                        <span className="fw-normal">
                                            {agencyInfo.phone
                                                ? agencyInfo.phone
                                                : '-'}
                                        </span>
                                    </div>
                                    <div className="fw-medium">
                                        <i className="ri-mail-line text-danger fs-15"></i>{' '}
                                        <span className="fw-normal mx-1">
                                            {agencyInfo.email}
                                        </span>
                                    </div>
                                    <div className="fw-medium">
                                        <i className="ri-user-line text-secondary fs-15"></i>{' '}
                                        <span className="fw-normal mx-1">
                                            {agencyInfo.userId}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="btn-list ms-auto d-flex align-items-center">
                                <button
                                    className="btn btn-info label-btn btn-sm ms-auto"
                                    onClick={() => navigate('/user/info')}
                                >
                                    <i className="ri-settings-3-line label-btn-icon me-2"></i>
                                    정보 수정
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AgencyInfoCard;
